(function (Drupal, once) {
  Drupal.behaviors.responsiveBackground = {
    attach: function (context, settings) {
      requestAnimationFrame(() => {
        const bgBlocks = once('responsive-background', '.parallax-background-image', context);

        bgBlocks.forEach(function (bgBlock) {
          let imageUrl = bgBlock.dataset.bgDesktopXl;

          if (window.innerWidth < 767 && bgBlock.dataset.bgMobile) {
            imageUrl = bgBlock.dataset.bgMobile;
          } else if (window.innerWidth < 991 && bgBlock.dataset.bgTablet) {
            imageUrl = bgBlock.dataset.bgTablet;
          } else if (window.innerWidth < 1199 && bgBlock.dataset.bgDesktop) {
            imageUrl = bgBlock.dataset.bgDesktop;
          }

          if (imageUrl) {
            bgBlock.style.backgroundImage = `url(${imageUrl})`;
          }
        });
      });
    }
  };
})(Drupal, once);
